// extracted by mini-css-extract-plugin
export default {"commit-discussion-comments":"Comment-module__commit-discussion-comments--WaMOe","discussion-comments-rose":"Comment-module__discussion-comments-rose--v1SXb"};